import React, { Component, Fragment } from 'react';
import CaseStudyDiv from './Components/CaseStudyDiv';

export default class CaseStudy extends Component {
  render() {
    return (
      <Fragment>
        <CaseStudyDiv />
      </Fragment>
    );
  }
}
